/**
 * Saving the account data export on web: the twin of
 * `account-export-save.ts`, same export. The JSON becomes a file download
 * through an anchor click (not `window.open`, which popup blockers stop
 * after the awaited fetch).
 */
export function saveAccountExport(
  json: string,
  fileName: string,
  _dialogTitle: string,
): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve();
  const url = URL.createObjectURL(
    new Blob([json], { type: 'application/json' }),
  );
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoked after the browser has taken the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return Promise.resolve();
}
